import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core'
import { ITrack } from '../../Interface/track'
import { RoutingPathService } from '../../services/environment.service'
import { I18nService, LgType } from '../../services/prod/i18n.service'
import { IconButtonSize } from '../buttons/button.types'

type TrackActionsDirection = 'row' | 'column'

@Component({
  selector: 'bmcore-track-actions',
  templateUrl: './bmcore-track-actions.component.html',
  styleUrls: ['./bmcore-track-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreTrackActionsComponent implements OnChanges, OnInit {
  freeBeatPageUrl = ''
  lg: LgType

  private readonly routingPathService = inject(RoutingPathService)
  private readonly i18nService = inject(I18nService)

  @Input() track: ITrack

  @Input() showFavouriteBtn = false
  @Input() showShareBtn = false

  @Input() showIconBtnVariant = false

  @Input() showLikeBtn = false
  @Input() showLikesCount = false

  @Input() buyBtnRouterPath = ''
  @Input() buyBtnText = ''
  @Input() isTrackInCart = false
  @Input() showBuyBtnMobMode = false
  @Input() showDownloadFreeBeatText = false

  @Input() iconButtonSize: IconButtonSize
  @Input() iconSize = 24

  @Input() direction: TrackActionsDirection = 'row'

  @Output() buyBtnClickEvent = new EventEmitter()

  ngOnChanges(changes: SimpleChanges): void {
    const { track } = changes
    const currentTrack: ITrack = track.currentValue

    if (currentTrack) {
      this.freeBeatPageUrl = this.routingPathService.getFreeBeatPageUrl(currentTrack.id)
    }
  }

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()
  }

  get isBeat(): boolean {
    return this.track?.type === 'beat'
  }

  get isFreeBeat(): boolean {
    return this.track?.type === 'free-beat'
  }

  get isSong(): boolean {
    return this.track?.type === 'song'
  }
}
